export default __webpack_public_path__ + "static/logo-14bcce78c2a3fd416ac57d654d9231bc.png";